import axios from 'axios'

export default class Hierarquia {
  constructor (tokenBearer, url, codigo) {
    this.url = `${url}/api/unimed/hierarquia/${codigo}`
    this.urlAdm = `${url}/api/hierarquia/paginada?`
    this.urlEdicao = `${url}/api/hierarquia/edicao/`
    this.urlDownload = `${url}/api/hierarquia/exportar?`
    this.tokenBearer = tokenBearer
  }

  getHierarquia () {
    return new Promise(async (resolve, reject) => {
      let optionsHierarquia = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseHierarquia = await axios(optionsHierarquia)
        resolve(responseHierarquia)
      } catch (err) {
        reject(err)
      }
    })
  }

  getHierarquiaAdm (args) {
    return new Promise(async (resolve, reject) => {
      let optionsHierarquia = {
        method: 'get',
        url: `${this.urlAdm}${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseHierarquia = await axios(optionsHierarquia)
        resolve(responseHierarquia)
      } catch (err) {
        reject(err)
      }
    })
  }

  getUnimedEdicao (id) {
    return new Promise(async (resolve, reject) => {
      let optionsHierarquia = {
        method: 'get',
        url: `${this.urlEdicao}${id}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseHierarquia = await axios(optionsHierarquia)
        resolve(responseHierarquia)
      } catch (err) {
        reject(err)
      }
    })
  }

  finalizarEdicao (data) {
    return new Promise(async (resolve, reject) => {
      let optionsHierarquia = {
        method: 'put',
        url: `${this.urlEdicao}finalizar`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let responseHierarquia = await axios(optionsHierarquia)
        resolve(responseHierarquia)
      } catch (err) {
        reject(err)
      }
    })
  }

  infoHierarquia (data) {
    return new Promise(async (resolve, reject) => {
      let optionsHierarquia = {
        method: 'post',
        url: `${this.urlEdicao}info`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let responseHierarquia = await axios(optionsHierarquia)
        resolve(responseHierarquia)
      } catch (err) {
        reject(err)
      }
    })
  }

  paisHierarquia (id) {
    return new Promise(async (resolve, reject) => {
      let optionsHierarquia = {
        method: 'post',
        url: `${this.urlEdicao}pais/${id}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseHierarquia = await axios(optionsHierarquia)
        resolve(responseHierarquia)
      } catch (err) {
        reject(err)
      }
    })
  }

  download (args = '') {
    let url = `${this.urlDownload}${args}`

    return new Promise(async (resolve, reject) => {
      let optionsAnexo = {
        method: 'get',
        url,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob'
      }

      try {
        let response = await axios(optionsAnexo)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
